import { render, staticRenderFns } from "./TricareChampva.vue?vue&type=template&id=76545d78&lang=pug"
import script from "./TricareChampva.vue?vue&type=script&lang=js"
export * from "./TricareChampva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports